var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 0.333984C3.81967 0.333984 0.833008 3.32065 0.833008 7.00065C0.833008 10.6807 3.81967 13.6673 7.49967 13.6673C11.1797 13.6673 14.1663 10.6807 14.1663 7.00065C14.1663 3.32065 11.1797 0.333984 7.49967 0.333984ZM8.16634 10.334H6.83301V6.33398H8.16634V10.334ZM8.16634 5.00065H6.83301V3.66732H8.16634V5.00065Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoVolume);
export default __webpack_public_path__ + "static/media/infoVolume.df91e89b11ad8340581b78f4d5a75f68.svg";
export { ForwardRef as ReactComponent };